










































import Vue from 'vue';
import ModalWrapper from '@/components/ModalWrapper.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import CopyToClipboard from '@/utils/CopyToClipboard';
import CreatePixelCode from '@/utils/CreatePixelCode';

export default Vue.extend({
  name: 'CreateInlinePixelForm',
  components: { ModalWrapper, FieldInput },
  props: {
    openModal: Boolean,
    pixel: {
      type: Object,
      default: () => {},
    },
    copyToClipboard: String,
    deleteButton: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    openModal: function(value) {
      this.modal = value;
    },
    pixel: function() {
      this.pixelCode = this.createPixelCode(this.pixel.public_key);
    },
    copyToClipboard: function(publicKey) {
      this.copyPixelCode(publicKey);
    },
  },
  methods: {
    input() {
      this.$emit('input');
      this.newPixelName = '';
    },
    addPixel() {
      this.$emit('submit', this.newPixelName);
      this.newPixelName = '';
    },
    createPixelCode(puclicKey: string) {
      return CreatePixelCode(puclicKey);
    },
    copyPixelCode(publicKey) {
      const pixelCode: string = this.createPixelCode(publicKey);
      CopyToClipboard(pixelCode);
    },
    deletePixel(pixelId) {
      this.$emit('delete', pixelId);
      this.modal = false;
    },
  },
  data() {
    return {
      modal: false,
      pixelCode: '',
      newPixelName: '',
    };
  },
});
